import { render, staticRenderFns } from "./MenuDialog.vue?vue&type=template&id=4c334540&scoped=true"
import script from "./MenuDialog.vue?vue&type=script&lang=js"
export * from "./MenuDialog.vue?vue&type=script&lang=js"
import style0 from "./MenuDialog.vue?vue&type=style&index=0&id=4c334540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c334540",
  null
  
)

export default component.exports